import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from "@angular/core";
import {DocumentRequirementRegistration} from "../../../../models/document_requirement_registration";
import {RelationValues} from "./RelationValues";

@Component({
  selector: "document-registration-modal",
  templateUrl: "./document-registration-modal.component.html",
})
export class DocumentRegistrationModal implements OnChanges {

  @Input()
  public requirementRegistration: DocumentRequirementRegistration;

  @Input()
  public requirement_to_upload: ElementRef;

  @Input()
  public requirement_to_show: ElementRef;

  @Input()
  public requirement_to_sign: ElementRef;

  @Input()
  public physical_result: ElementRef;

  @Input()
  public dematerialized_result: ElementRef;

  @Input()
  public requirement_to_print_upload: ElementRef;

  public selectedRelationValues: any[] = [];
  public relationsValues: any[] = [];

  @Output()
  public onChange = new EventEmitter();

  @Output()
  public onSave = new EventEmitter();

  @Output()
  public onCancel = new EventEmitter();

  public ngOnChanges(): void {
    this.loadSelectedRelationValues(this.requirementRegistration);
    this.loadRelationValues();
  }

  public loadRelationValues() {
    this.relationsValues = [];
    let allValues = Object.keys(RelationValues);
    allValues = allValues.slice(allValues.length / 2);
    for (const entry of allValues) {
      this.relationsValues.push({id: RelationValues[entry], text: this.getTranslation(entry)});
    }
  }

  public selected(): void {
    this.fireOnChangeEvent();
  }

  public removed(): void {
    this.fireOnChangeEvent();
  }

  public fireOnChangeEvent() {
    const srv = this.relationsValues.filter((rv) => this.selectedRelationValues.indexOf(rv.id) > -1);
    this.updateObjectRequirements(this.requirementRegistration, srv);
    this.onChange.emit({requirementRegistration: this.requirementRegistration, selectedRelationValues: srv});
  }

  public loadSelectedRelationValues(documentRequirementRegistration: DocumentRequirementRegistration) {
  this.selectedRelationValues = [];
  if (documentRequirementRegistration) {
      if (documentRequirementRegistration.toShow) {
        this.selectedRelationValues.push(RelationValues.requirement_to_show);
      }
      if (documentRequirementRegistration.toSign) {
        this.selectedRelationValues.push(RelationValues.requirement_to_sign);
      }
      if (documentRequirementRegistration.toUpload) {
        this.selectedRelationValues.push(RelationValues.requirement_to_upload);
      }
      // if (documentRequirementRegistration.toPrintUpload) {
      //     this.selectedRelationValues.push(RelationValues.requirement_to_print_upload);
      // }
      if (documentRequirementRegistration.physicalResult) {
        this.selectedRelationValues.push(RelationValues.physical_result);
      }
      if (documentRequirementRegistration.dematerializedResult) {
        this.selectedRelationValues.push(RelationValues.dematerialized_result);
      }
    }
  }

  public getTranslation(name: string) {
    if (name === "requirement_to_show") {
      return this.requirement_to_show !== undefined ? this.requirement_to_show.nativeElement.textContent.trim().toString() : "";
    } else if (name === "requirement_to_upload") {
      return  this.requirement_to_upload !== undefined ? this.requirement_to_upload.nativeElement.textContent.trim().toString() : "";
    } else if (name === "requirement_to_sign") {
      return this.requirement_to_sign !== undefined ? this.requirement_to_sign.nativeElement.textContent.trim().toString() : "";
    } else if (name === "physical_result") {
      return this.physical_result !== undefined ? this.physical_result.nativeElement.textContent.trim().toString() : "";
    } else if (name === "dematerialized_result") {
      return this.dematerialized_result !== undefined ? this.dematerialized_result.nativeElement.textContent.trim().toString() : "";
    } else if (name === "requirement_to_print_upload") {
        return this.requirement_to_print_upload !== undefined ? this.requirement_to_print_upload.nativeElement.textContent.trim().toString() : "";
    }
  }

  public updateObjectRequirements(requirementRegistrationObj: DocumentRequirementRegistration, selectedRelationValuesArr) {
    requirementRegistrationObj.toShow = false;
    requirementRegistrationObj.toSign = false;
    requirementRegistrationObj.toUpload = false;
    requirementRegistrationObj.physicalResult = false;
    requirementRegistrationObj.dematerializedResult = false;
    requirementRegistrationObj.toPrintUpload = false;
    for (const entry of selectedRelationValuesArr) {
      if (RelationValues[entry.id] === RelationValues[RelationValues.requirement_to_show]) {
        requirementRegistrationObj.toShow = true;
      }
      if (RelationValues[entry.id] === RelationValues[RelationValues.requirement_to_upload]) {
        requirementRegistrationObj.toUpload = true;
      }
      if (RelationValues[entry.id] === RelationValues[RelationValues.requirement_to_sign]) {
        requirementRegistrationObj.toSign = true;
      }
      // if (RelationValues[entry.id] === RelationValues[RelationValues.requirement_to_print_upload]) {
      //   requirementRegistrationObj.toPrintUpload = true;
      // }
      if (RelationValues[entry.id] === RelationValues[RelationValues.physical_result]) {
        requirementRegistrationObj.physicalResult = true;
      }
      if (RelationValues[entry.id] === RelationValues[RelationValues.dematerialized_result]) {
        requirementRegistrationObj.dematerializedResult = true;
      }
    }
  }
}
